import PlayCircleOutlined from '@ant-design/icons/lib/icons/PlayCircleOutlined';
import ShareAltOutlined from '@ant-design/icons/lib/icons/ShareAltOutlined';
import { Progress, Button, Col, Form, FormInstance, Image, Row, Statistic } from 'antd';
import TextArea from 'antd/lib/input/TextArea';
import React, { Component } from 'react';
import { FormattedMessage, injectIntl, WrappedComponentProps } from 'react-intl';
import { RouteComponentProps } from 'react-router-dom';
import LayoutComponent from '../../components/LayoutComponent/LayoutComponent';
import CustomContext from '../../context/CustomContext';
import notificationService from '../../services/NotificationService';
import UploadComponent from './UploadComponent/UploadComponent';
import { PlusOutlined } from '@ant-design/icons';

class PlayerDataPage extends Component<Props, State> {
    static contextType = CustomContext;
    context!: React.ContextType<typeof CustomContext>;
    formRef = React.createRef<FormInstance>();

    constructor(props: Props) {
        super(props);
        this.state = {};
    }

    componentDidMount() {
        this.init();
    }

    /** METHODS **/

    init = async () => {
        try {
            this.setState({ loading: true });

            this.setState({ loading: false });
        } catch (error) {
            notificationService.displayError(error, this.props.intl);
        } finally {
            this.setState({ loading: false });
        }
    };

    showModal = (visible: boolean) => {
        this.setState({ modalVisible: visible });
    };

    /*** COMPONENTS ***/

    renderHeader = (desktop: boolean): React.ReactElement | undefined => {
        if (desktop) {
            return (
                <Form ref={this.formRef} colon={false} layout="vertical">
                    <Row gutter={[28, 0]}>
                        <Col span={3}>
                            <Button shape="round">
                                <FormattedMessage id="player.data.private" />
                            </Button>
                        </Col>
                        <Col span={3}>
                            <Button shape="round">
                                <FormattedMessage id="player.data.public" />
                            </Button>
                        </Col>
                        <Col span={3}>
                            <Button shape="round" onClick={() => this.showModal(true)}>
                                <FormattedMessage id="player.data.upload" />
                            </Button>
                        </Col>
                        <Col span={3}>
                            <Button shape="round">
                                <FormattedMessage id="player.data.share" />
                            </Button>
                        </Col>
                    </Row>
                </Form>
            );
        } else {
            return <Button type="ghost" icon={<ShareAltOutlined />} />;
        }
    };

    renderButtons = (desktop: boolean): React.ReactElement | undefined => {
        if (desktop) {
            return (
                <>
                    <Row gutter={[28, 0]}>
                        <Col span={4}>
                            <Statistic title={<FormattedMessage id="player.data.speed" />} value={1.83 + 's'} />
                            <Button
                                shape={'round'}
                                style={{ marginTop: 16 }}
                                type="primary"
                                icon={<PlayCircleOutlined />}
                            >
                                <FormattedMessage id="player.data.watch" />
                            </Button>
                        </Col>
                        <Col span={4}>
                            <Statistic
                                title={<FormattedMessage id="player.data.ability" />}
                                value={5.91 + 's'}
                                precision={2}
                            />
                            <Button
                                shape={'round'}
                                style={{ marginTop: 16 }}
                                type="primary"
                                icon={<PlayCircleOutlined />}
                            >
                                <FormattedMessage id="player.data.watch" />
                            </Button>
                        </Col>
                        <Col span={4}>
                            <Statistic
                                title={<FormattedMessage id="player.data.explosion" />}
                                value={13.2 + '"'}
                                precision={2}
                            />
                            <Button
                                shape={'round'}
                                style={{ marginTop: 16 }}
                                type="primary"
                                icon={<PlayCircleOutlined />}
                            >
                                <FormattedMessage id="player.data.watch" />
                            </Button>
                        </Col>
                    </Row>
                    <Row gutter={[28, 0]}>
                        <Col span={8}>
                            <div>
                                <h1>
                                    <FormattedMessage id="player.data.history" />
                                </h1>
                            </div>
                        </Col>
                    </Row>
                    <Row gutter={[28, 0]}>
                        <Col span={8}>
                            <div>
                                <h2>
                                    <FormattedMessage id="player.data.performance" />
                                </h2>
                            </div>
                            <div>
                                <h3>
                                    <FormattedMessage id="player.data.detail" />
                                </h3>
                            </div>
                        </Col>
                        <Col span={8}>
                            <Button icon={<PlusOutlined />} shape="round">
                                <FormattedMessage id="player.data.addMetric" />
                            </Button>
                        </Col>
                    </Row>
                    <Row gutter={[28, 0]}>
                        <Col span={8}>
                            <div>
                                <Progress percent={32} format={(percent) => `${percent! * 0.1}`} />
                            </div>
                            <div>
                                <Progress percent={57} status="exception" format={(percent) => `${percent! * 0.1}`} />
                            </div>
                            <div>
                                <FormattedMessage id="player.data.recomendation" />
                            </div>
                        </Col>
                        <Col span={8}>
                            <div>
                                <Button shape={'round'} type="primary" size="small" icon={<PlayCircleOutlined />}>
                                    <FormattedMessage id="player.data.watch" />
                                </Button>
                            </div>
                            <div>
                                <Button shape={'round'} type="primary" size="small" icon={<PlusOutlined />}>
                                    <FormattedMessage id="player.data.media" />
                                </Button>
                            </div>
                        </Col>
                    </Row>
                    <Row gutter={[28, 0]}>
                        <Col span={8}>
                            <Button size="large">
                                <FormattedMessage id="player.data.tenYardDash" />
                            </Button>
                            <Button size="large">
                                <FormattedMessage id="player.data.thirtyYardDash" />
                            </Button>
                            <Button size="large">
                                <FormattedMessage id="player.data.fiveTenFive" />
                            </Button>
                            <Button size="large">
                                <FormattedMessage id="player.data.verticalJump" />
                            </Button>
                            <Button size="large">
                                <FormattedMessage id="player.data.exitVelo" />
                            </Button>
                            <Button size="large">
                                <FormattedMessage id="player.data.batSpeed" />
                            </Button>
                        </Col>
                    </Row>
                    <Row gutter={[28, 0]}>
                        <Col span={8}>
                            <Form.Item
                                label={
                                    <h1>
                                        <FormattedMessage id="player.data.stats" />
                                    </h1>
                                }
                                name="stats"
                            >
                                <TextArea rows={4} />
                            </Form.Item>
                        </Col>
                    </Row>
                </>
            );
        } else {
            return (
                <>
                    <Row gutter={[28, 0]}>
                        <Col span={6}>
                            <Statistic title={<FormattedMessage id="player.data.speed" />} value={1.83 + 's'} />
                            <Button
                                shape={'circle'}
                                style={{ marginTop: 16 }}
                                type="primary"
                                icon={<PlayCircleOutlined />}
                            ></Button>
                        </Col>
                        <Col span={6}>
                            <Statistic
                                title={<FormattedMessage id="player.data.ability" />}
                                value={5.91 + 's'}
                                precision={2}
                            />
                            <Button
                                shape={'circle'}
                                style={{ marginTop: 16 }}
                                type="primary"
                                icon={<PlayCircleOutlined />}
                            ></Button>
                        </Col>
                        <Col span={6}>
                            <Statistic
                                title={<FormattedMessage id="player.data.explosion" />}
                                value={13.2 + '"'}
                                precision={2}
                            />
                            <Button
                                shape={'circle'}
                                style={{ marginTop: 16 }}
                                type="primary"
                                icon={<PlayCircleOutlined />}
                            ></Button>
                        </Col>
                    </Row>
                    <Row gutter={[28, 0]}>
                        <Col span={24}>
                            <div>
                                <h1>
                                    <FormattedMessage id="player.data.history" />
                                </h1>
                            </div>
                        </Col>
                    </Row>
                    <Row gutter={[28, 0]}>
                        <Col span={12}>
                            <div>
                                <h4>
                                    <FormattedMessage id="player.data.performance" />
                                </h4>
                            </div>
                            <div>
                                <h5>
                                    <FormattedMessage id="player.data.detail" />
                                </h5>
                            </div>
                        </Col>
                        <Col span={12}>
                            <Button icon={<PlusOutlined />} shape="round"></Button>
                        </Col>
                    </Row>
                    <Row gutter={[28, 0]}>
                        <Col span={12}>
                            <div>
                                <Progress percent={32} format={(percent) => `${percent! * 0.1}`} />
                            </div>
                            <div>
                                <Progress percent={57} status="exception" format={(percent) => `${percent! * 0.1}`} />
                            </div>
                            <div>
                                <FormattedMessage id="player.data.recomendation" />
                            </div>
                        </Col>
                        <Col span={12}>
                            <div>
                                <Button
                                    shape={'round'}
                                    type="primary"
                                    size="small"
                                    icon={<PlayCircleOutlined />}
                                ></Button>
                            </div>
                            <div>
                                <Button shape={'round'} type="primary" size="small" icon={<PlusOutlined />}></Button>
                            </div>
                        </Col>
                    </Row>
                    <Row gutter={[28, 0]}>
                        <Col span={24}>
                            <Button size="large">
                                <FormattedMessage id="player.data.tenYardDash" />
                            </Button>
                            <Button size="large">
                                <FormattedMessage id="player.data.thirtyYardDash" />
                            </Button>
                            <Button size="large">
                                <FormattedMessage id="player.data.fiveTenFive" />
                            </Button>
                            <Button size="large">
                                <FormattedMessage id="player.data.verticalJump" />
                            </Button>
                            <Button size="large">
                                <FormattedMessage id="player.data.exitVelo" />
                            </Button>
                            <Button size="large">
                                <FormattedMessage id="player.data.batSpeed" />
                            </Button>
                        </Col>
                    </Row>
                </>
            );
        }
    };

    renderContent = (desktop: boolean): React.ReactElement | undefined => {
        const { modalVisible } = this.state;
        return (
            <>
                <UploadComponent visible={modalVisible} onCancel={() => this.showModal(false)} />
                <Form ref={this.formRef} colon={false} layout="vertical">
                    <Row gutter={[28, 0]}>
                        <Col xs={24} md={8}>
                            <Image
                                width={200}
                                height={200}
                                src="error"
                                fallback="data:image/png;base64,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"
                            />
                        </Col>
                        <Col xs={24} md={8}>
                            <div>
                                <h1>Carter Butcher</h1>
                            </div>
                        </Col>
                    </Row>

                    <Row gutter={[28, 0]}>
                        <Col xs={24} md={8}>
                            <div>
                                <h1>
                                    <FormattedMessage id="player.data.about" />
                                </h1>
                            </div>
                        </Col>
                    </Row>
                    <Row gutter={[28, 0]}>
                        <Col xs={24} md={8}>
                            <div>
                                <FormattedMessage id="player.data.description" />
                            </div>
                        </Col>
                    </Row>
                    <Row gutter={[28, 0]}>
                        <Col xs={24} md={8}>
                            <div>
                                <h1>
                                    <FormattedMessage id="player.data.records" />
                                </h1>
                            </div>
                        </Col>
                    </Row>
                    {this.renderButtons(desktop)}
                </Form>
            </>
        );
    };

    render() {
        const playerId = this.props.match.params.id;
        return (
            <LayoutComponent
                page="player-data"
                content={this.renderContent}
                header={this.renderHeader}
                playerId={playerId}
            />
        );
    }
}
export default injectIntl(PlayerDataPage);

type ParamsType = { id: string };
interface Props extends RouteComponentProps<ParamsType>, WrappedComponentProps {}

interface State {
    modalVisible?: boolean;
    loading?: boolean;
}
